import { render } from "./collapse.vue?vue&type=template&id=1021518d&scoped=true"
import script from "./collapse.vue?vue&type=script&lang=js"
export * from "./collapse.vue?vue&type=script&lang=js"

import "./collapse.vue?vue&type=style&index=0&id=1021518d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1021518d"

export default script